"use client"

import React, { useState } from "react"
import { BackgroundGraph } from "./components/BackgroundGraph"
import RunConfigWizard from "./components/RunConfigWizard"

export default function ConnectionStatus() {
  const [wizardOpen, setWizardOpen] = useState(false)

  const handleRunSubmit = async ({ conn, runParams }) => {
    try {
      sessionStorage.setItem("pg_demo_mode", "true")
      sessionStorage.setItem(
        "pg_demo_conn",
        JSON.stringify({ ...conn, ts: Date.now() })
      )
      sessionStorage.setItem("pg_last_run_params", JSON.stringify(runParams))
    } catch (e) {
      console.warn("Failed to persist demo session", e)
    }

    window.location.href = "/GraphInfo"
  }

  return (
    <div className="relative min-h-screen flex flex-col overflow-hidden">
      <BackgroundGraph nodeCount={90} linkDistance={120} speed={0.18} />

      <div className="relative z-10 flex flex-1 items-center justify-center p-4">
        <div className="w-full max-w-2xl rounded-xl border bg-white/90 p-8 shadow-lg backdrop-blur
                        border-slate-200
                        dark:border-slate-800 dark:bg-slate-900/80">
          <img
            src="/logo-light.png"
            alt="PG-HIVE Logo"
            className="mx-auto mb-4 block h-10 dark:hidden"
          />
          <img
            src="/logo-dark.png"
            alt="PG-HIVE Logo"
            className="mx-auto mb-4 hidden h-10 dark:block"
          />

          <p className="mb-4 text-center text-xl font-semibold">
            A new, open-source tool for schema discovery for large property graph datasets.
          </p>

          <button
            onClick={() => setWizardOpen(true)}
            className="mb-2 flex w-full items-center justify-center rounded-lg bg-blue-600 px-6 py-3 text-xl font-bold text-white hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          >
            Try it out!
          </button>
        </div>
      </div>

      <RunConfigWizard
        open={wizardOpen}
        onOpenChange={setWizardOpen}
        initialRunParams={null}
        onSubmit={handleRunSubmit}
      />
    </div>
  )
}
